
import Stat from 'Shared/components/Stat'
import './PageContainer.scoped.scss'

function percentage(partialValue, totalValue) {
    if (partialValue === 0 || totalValue === 0) {
        return 0
    }
    return Math.round((100 * partialValue) / totalValue)
}

function FlowStats({ }) {
    const { stats, actions } = useSel((s) => s.flow)
    const hasDonateAction = useMemo(() => actions?.find((action) => action.kind === 'donate'), [actions])

    return <div>
        <div className='box grid margin-top double no-side-padding' id='analytics'>
            <div className="stat-container">
                <Stat
                    borderBottom={false}
                    size={'vertical'}
                    label={`Started page`}
                    primary={stats?.flowsStarted || 0}
                />
            </div>
            <div className="stat-container">
                <Stat
                    borderBottom={false}
                    size={'vertical'}
                    label={`Completed page`}
                    primary={stats?.flowsCompleted || 0}
                />
            </div>
            <div className="stat-container">
                <Stat
                    borderBottom={false}
                    size={'vertical'}
                    label={`Completion rate`}
                    primary={`${percentage(stats?.flowsCompleted || 0, stats?.flowsStarted || 0)}%`}
                />
            </div>
        </div>
        {hasDonateAction && (
            <div className='box grid margin-top double no-side-padding' id='analytics'>
                <div className="stat-container">
                    <Stat
                        borderBottom={false}
                        size={'vertical'}
                        label={`Donations`}
                        primary={stats?.donationsCount || 0}
                    />
                </div>
                <div className="stat-container">
                    <Stat
                        borderBottom={false}
                        size={'vertical'}
                        label={`Amount raised`}
                        primary={'£' + (stats?.donationsSum || 0)}
                    />
                </div>
                <div className="stat-container">
                    <Stat
                        borderBottom={false}
                        size={'vertical'}
                        label={`Average donation amount`}
                        primary={'£' + (stats?.donationsAverage || 0)}
                    />
                </div>
            </div>)}
    </div>

}

export default FlowStats